import React from 'react'
import { Stack, Tooltip, Typography } from '@mui/material'
import { AlertProps } from './_props'
import sxs from './_sxs'
import { severityProps } from './severity'
import AlertIcon from './AlertIcon'

export const Alert: React.FC<AlertProps> = ({
    title,
    text,
    icon,
    iconAlignment = 'center',
    secondaryIcon,
    secondaryIconAlignment = 'flex-start',
    severity = 'INFO',
    tooltip = undefined,
}) => {
    const severityStyle = severityProps[severity]
    return (
        <Tooltip
            title={tooltip}
            hidden={!tooltip}
            arrow
            placement="top-start"
            componentsProps={{
                tooltip: {
                    sx: sxs.alertTooltip,
                },
                arrow: {
                    sx: sxs.alertTooltipArrow,
                },
            }}
        >
            <Stack sx={[sxs.alert, severityStyle.classes.container]}>
                <AlertIcon icon={icon ?? severityStyle.icon} iconAlignment={iconAlignment} />
                <Stack sx={sxs.alertContentContainer}>
                    <Stack sx={sxs.alertTitleContainer}>
                        <Typography sx={[sxs.alertTitle, severityStyle.classes.element]}>{title}</Typography>
                    </Stack>
                    {text && <Typography sx={[sxs.alertText, severityStyle.classes.element]}>{text}</Typography>}
                </Stack>
                <AlertIcon icon={secondaryIcon ?? severityStyle.secondaryIcon} iconAlignment={secondaryIconAlignment} />
            </Stack>
        </Tooltip>
    )
}
